<script>
  import Datepicker from 'svelte-calendar/src/Components/Datepicker.svelte';
  import {getContext, onMount} from 'svelte';
  import lang from './ExportHistoryDialog.lang';
  import {mc} from '@/core';
  import {Button, Modal} from '@/widgets';
  import {TIME_DAY, TIME_WEEK, TIME_MONTH} from './const';
  import {timeRangeInfo$} from './stream';

  const LG = getContext('LG');
  const dateFormat = '#{Y}-#{m}-#{d}';

  let visible = false;
  let loading = false;
  let title;
  let rangeType = 'hours';
  let formattedStartTime = '';
  let formattedEndTime = '';
  let context = null;

  $: startTime = genStartTime(formattedStartTime);

  function genStartTime(formattedStartTime) {
    if (formattedStartTime) {
      return new Date(formattedStartTime);
    }
    return new Date();
  }

  onMount(() =>
    mc.subscribe('export-history', 'dialog-show', (payload) => {
      visible = true;
      rangeType = 'hours';
      context = payload;
      context.LG = LG;
      title = payload.title;
    })
  );

  onMount(() =>
    mc.subscribe('download', 'disappear', () => {
      visible = false;
      loading = false;
    })
  );

  function getDateSixMonthBefore(dateTime) {
    const date = new Date(dateTime);
    const currentMonth = date.getMonth();
    date.setMonth(currentMonth - 6);
    // 处理跨年时日期自动调整的问题
    if (date.getMonth() !== (currentMonth - 6 + 12) % 12) {
      date.setDate(0);
    }
    return date;
  }

  function handleExport() {
    if (rangeType === 'Custom') {
      const start = new Date(formattedStartTime).getTime();
      const end = new Date(formattedEndTime).getTime();
      const sixBeforeEndTime = getDateSixMonthBefore(end).getTime();
      if (start - sixBeforeEndTime < 0) {
        mc.send('three-months-tip', 'dialog-show');
        return;
      }
    }
    loading = true;
    timeRangeInfo$.next({rangeType, formattedStartTime, formattedEndTime, context});
  }
</script>

<style>
  .main {
    margin: 24px auto;
    width: 400px;
  }
  .w200 {
    width: 200px;
  }
  .bg {
    border-radius: 2px;
    padding: 20px;
    width: 360px;
    height: 60px;
    background: #f9f9f9;
  }
  .main .date-pick :global(.calendar-button) {
    border: 0;
    border-radius: 0;
    padding: 10px 0;
    width: 120px;
    text-align: left;
    font-size: 14px;
    background: transparent;
    box-shadow: 0 0 0 0 transparent;
  }
  .main :global(.calendar-button:focus) {
    border: 0;
    background-color: transparent;
  }
  .main .date-pick :global(.contents-wrapper) {
    position: fixed;
    transform: translate(-56%, -90%) !important;
  }
  .main .date-box1 :global(.contents-wrapper) {
    position: fixed;
    transform: translate(-56%, -90%) !important;
  }
  .main .date-box2 :global(.contents-wrapper) {
    position: fixed;
    transform: translate(-10%, -90%) !important;
  }
  .main :global(.datepicker) {
    margin: 0;
  }
  .main .disable :global(.calendar-button) {
    color: var(--T3);
  }
  .w140 {
    width: 140px;
  }
  .date-box1,
  .date-box2 {
    border-bottom: 1px solid #e5e5e5;
  }
  .disable {
    pointer-events: none;
  }
</style>

{#if visible}
  <Modal {visible}>
    <div class="lh24 b df jcsb" slot="header">
      <div class="f16 T1 fw2 lh24">{title} (CSV)</div>
      <i class="iconfont lh12 f12 T4 cp df aic" on:click={() => (visible = false)}>&#xe614;</i>
    </div>
    <div id="container" style="display: none" />
    <div class="main df fdc">
      <div class="df jcsb">
        {#each TIME_DAY(LG) as item}
          <div class="T3 w200 ml20 df cp" on:click={() => (rangeType = item.type)}>
            <i class="iconfont mr8" class:BLUE={rangeType === item.type}>
              {@html rangeType === item.type ? '&#xe621;' : '&#xe622;'}
            </i>
            <div class:T2={rangeType === item.type}>{item.name}</div>
          </div>
        {/each}
      </div>
      <div class="df jcsb mt20">
        {#each TIME_WEEK(LG) as item}
          <div class="T3 w200 ml20 df cp" on:click={() => (rangeType = item.type)}>
            <i class="iconfont mr8" class:BLUE={rangeType === item.type}>
              {@html rangeType === item.type ? '&#xe621;' : '&#xe622;'}
            </i>
            <div class:T2={rangeType === item.type}>{item.name}</div>
          </div>
        {/each}
      </div>
      <div class="df jcsb mt20">
        {#each TIME_MONTH(LG) as item}
          <div class="T3 w200 ml20 df cp" on:click={() => (rangeType = item.type)}>
            <i class="iconfont mr8" class:BLUE={rangeType === item.type}>
              {@html rangeType === item.type ? '&#xe621;' : '&#xe622;'}
            </i>
            <div class:T2={rangeType === item.type}>{item.name}</div>
          </div>
        {/each}
      </div>
      <div class="bg mt20">
        <div class="T3 df cp" on:click={() => (rangeType = 'Custom')}>
          <i class="iconfont mr8" class:BLUE={rangeType === 'Custom'}>
            {@html rangeType === 'Custom' ? '&#xe621;' : '&#xe622;'}
          </i>
          <div class:T2={rangeType === 'Custom'}>{LG(lang.Custom6Month)}</div>
        </div>
        <div class="df jcsb date-pick mt20 T4">
          <div class="df jcsb w140 date-box1" class:disable={rangeType !== 'Custom'}>
            <Datepicker format={dateFormat} end={new Date()} bind:formattedSelected={formattedStartTime} />
            <i class="iconfont df aic" class:BLUE={rangeType === 'Custom'}>&#xe617;</i>
          </div>
          <i class="iconfont df aic jcc f12" class:T3={rangeType === 'Custom'}>&#xe618;</i>
          <div class="df jcsb w140 date-box2" class:disable={rangeType !== 'Custom'}>
            <Datepicker format={dateFormat} start={startTime} end={new Date()} bind:formattedSelected={formattedEndTime} />
            <i class="iconfont df aic" class:BLUE={rangeType === 'Custom'}>&#xe617;</i>
          </div>
        </div>
      </div>
    </div>
    <div class="df jcfe mt24" slot="footer">
      <Button type="default" on:click={() => (visible = false)}>{LG(lang.Cancel)}</Button>
      <Button type="primary" on:click={handleExport} {loading}>{LG(lang.Export)}</Button>
    </div>
  </Modal>
{/if}
